// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-page {
  min-height: 100vh;
  background: transparent;
  position: relative;
}

/* Fixed background image for admin page */
.admin-page::after {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--background-image, none);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: var(--color-primary);
  background-blend-mode: multiply;
  background-attachment: fixed;
  pointer-events: none;
  z-index: -1;
}

/* Gradient overlay for admin page */
.admin-page::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--color-gradient-start) 0%, var(--color-gradient-end) 100%);
  opacity: 0.2;
  pointer-events: none;
  z-index: 0;
}

.admin-content {
  display: flex;
  align-items: flex-start;
  padding: 1rem 1.5rem;
  gap: 0;
  min-height: calc(100vh - 64px);
}

.admin-sidebar {
  width: 175px;
  flex-shrink: 0;
  background: var(--color-card-bg);
  border-radius: 0.5rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 1rem;
  transition: width 0.2s ease;
  overflow: hidden;
}

.admin-sidebar.collapsed {
  width: 36px;
  padding: 0.25rem;
  align-items: center;
}

.admin-sidebar-toggle {
  align-self: flex-end;
  background: none;
  border: 1px solid var(--color-border, #374151);
  border-radius: 0.25rem;
  cursor: pointer;
  color: #9ca3af;
  padding: 0.2rem 0.4rem;
  font-size: 0.85rem;
  line-height: 1;
  margin-bottom: 0.5rem;
  transition: color 0.15s;
}

.admin-sidebar.collapsed .admin-sidebar-toggle {
  align-self: center;
  margin-bottom: 0;
}

.admin-sidebar-toggle:hover {
  color: #3b82f6;
}

.admin-nav-item {
  display: block;
  width: 100%;
  padding: 0.45rem 0.75rem;
  background: none;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.78rem;
  font-weight: 500;
  color: #9ca3af;
  text-align: left;
  white-space: nowrap;
  transition: all 0.15s;
  margin-bottom: 0.1rem;
}

.admin-nav-item:hover {
  background: rgba(59, 130, 246, 0.12);
  color: #3b82f6;
}

.admin-nav-item.active {
  background: #3b82f6;
  color: #fff;
}

.admin-main {
  flex: 1 1;
  min-width: 0;
  padding-left: 1.25rem;
}

.admin-section {
  background: white;
  border-radius: 0.5rem;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.admin-section h2 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: var(--color-text-on-background);
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
}

.admin-table thead {
  background: #f9fafb;
}

.admin-table th {
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
}

.admin-table th[style*="cursor: pointer"]:hover {
  background: #e5e7eb;
  color: #1f2937;
}

.admin-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.admin-table tbody tr:hover {
  background: #f9fafb;
}

.admin-table .btn-edit,
.admin-table .btn-delete,
.btn-edit,
.btn-delete {
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s;
}

.admin-table .btn-edit,
.btn-edit {
  background: #3b82f6;
  color: white;
}

.admin-table .btn-edit:hover,
.btn-edit:hover {
  background: #2563eb;
}

.admin-table .btn-delete,
.btn-delete {
  background: #ef4444;
  color: white;
}

.admin-table .btn-delete:hover,
.btn-delete:hover {
  background: #dc2626;
}

.admin-modal {
  max-width: 600px;
  width: 90%;
}

.admin-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.admin-form.compact-form {
  gap: 0.5rem;
}

.admin-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.admin-form label {
  font-weight: 500;
  color: #374151;
}

.admin-form input[type="text"],
.admin-form input[type="email"],
.admin-form input[type="password"] {
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 1rem;
  background-color: #ffffff;
}

/* Compact form rows */
.compact-row {
  display: grid;
  grid-template-columns: 110px 1fr;
  align-items: center;
  gap: 0.5rem;
}

.compact-row label {
  font-size: 0.8rem;
  color: #6b7280;
  font-weight: 500;
  margin: 0;
}

.compact-row input[type="text"],
.compact-row input[type="email"],
.compact-row .password-input {
  padding: 0.35rem 0.5rem;
  font-size: 0.85rem;
}

.compact-row select {
  padding: 0.35rem 0.5rem;
  font-size: 0.85rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background: #ffffff;
}

.compact-section-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #9ca3af;
  margin-top: 0.25rem;
  border-top: 1px solid #f3f4f6;
  padding-top: 0.4rem;
}

.compact-toggle-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 1rem;
}

.compact-check {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 0.8rem;
}

.compact-check input[type="checkbox"] {
  width: 1rem;
  height: 1rem;
  cursor: pointer;
  margin: 0;
}

.compact-check span {
  color: #374151;
}

.compact-roles {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 1rem;
}

.admin-form textarea {
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  background-color: #ffffff;
  font-family: inherit;
  resize: vertical;
}

.admin-form textarea:disabled {
  background-color: #e5e7eb;
  color: #6b7280;
  cursor: not-allowed;
}

.admin-form textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.admin-form input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.roles-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 0.375rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.checkbox-label input[type="checkbox"] {
  width: 1.25rem;
  height: 1.25rem;
  cursor: pointer;
}

.checkbox-label span {
  color: #374151;
}

.role-description {
  color: #6b7280;
  font-size: 0.875rem;
}

.modal-actions .btn-save,
.modal-actions .btn-cancel,
.btn-save,
.btn-cancel {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 9999px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}

.modal-actions .btn-save,
.btn-save {
  background: #3b82f6;
  color: white;
}

.modal-actions .btn-save:hover,
.btn-save:hover:not(:disabled) {
  background: #2563eb;
}

.btn-save:disabled {
  background: #6b7280;
  cursor: not-allowed;
  opacity: 0.6;
}

.modal-actions .btn-cancel,
.btn-cancel {
  background: #6b7280;
  color: white;
}

.modal-actions .btn-cancel:hover,
.btn-cancel:hover {
  background: #4b5563;
}

/* Generic button styles for Interfaces tab */
.button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 9999px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}

.button-primary {
  background: #3b82f6;
  color: white;
}

.button-primary:hover:not(:disabled) {
  background: #2563eb;
}

.button-primary:disabled {
  background: #6b7280;
  cursor: not-allowed;
  opacity: 0.6;
}

.button-secondary {
  background: #6b7280;
  color: white;
}

.button-secondary:hover:not(:disabled) {
  background: #4b5563;
}

.button-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* ============== Interface & System Settings Styles ============== */

/* Dark banner header for interface config sections (Email, SMS, App URL, OpenAI) */
.admin-interface-header {
  font-size: 1.25rem;
  padding: 0.75rem 1rem;
  margin: 0 -1rem 1.5rem -1rem;
  background-color: var(--color-text);
  color: white;
  border-radius: 0.25rem;
}

/* Underline header for system settings sections (Theme, Threshold, Cleanup) */
.admin-settings-header {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid var(--color-border);
  color: var(--color-text);
}

/* Config section spacing */
.admin-config-section {
  margin-top: 3rem;
}

.admin-config-section:first-child {
  margin-top: 0;
}

/* System settings section spacing */
.admin-settings-section {
  margin-top: 2rem;
}

/* Description paragraph below section headers */
.admin-section-description {
  color: var(--color-text-secondary);
  margin-bottom: 1.5rem;
}

/* Narrow form wrapper (600px max) */
.admin-form-narrow {
  max-width: 600px;
}

/* Helper text below form fields */
.admin-help-text {
  color: var(--color-text-secondary);
  font-size: 0.875rem;
}

.admin-help-text a {
  color: var(--color-primary);
}

.admin-help-text.block {
  display: block;
  margin-top: 0.25rem;
}

/* Row of action buttons at bottom of forms */
.admin-button-row {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

/* Test section divider */
.admin-test-divider {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--color-border);
}

.admin-test-divider h4 {
  margin-bottom: 1rem;
}

/* Test input + button row */
.admin-test-row {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
  max-width: 600px;
}

.admin-test-row .form-group {
  flex: 1 1;
  margin-bottom: 0;
}

.admin-test-row button {
  height: fit-content;
}

/* Inline checkbox/radio label (row direction) */
.admin-checkbox-inline {
  flex-direction: row;
  align-items: center;
  margin-bottom: 1.5rem;
}

.admin-checkbox-inline.compact {
  margin-bottom: 1rem;
}

.admin-checkbox-inline.no-margin {
  margin-bottom: 0;
}

/* Radio option group */
.admin-radio-group {
  display: flex;
  gap: 2rem;
  margin-bottom: 0.5rem;
}

.admin-radio-group label {
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

.admin-radio-group input[type="radio"] {
  margin-right: 0.5rem;
}

/* Email provider selection */
.admin-provider-selection {
  max-width: 600px;
  margin-bottom: 2rem;
}

.admin-provider-selection > label {
  display: block;
  margin-bottom: 0.75rem;
  font-weight: 500;
}

/* Full-width textarea */
.admin-textarea-full {
  width: 100%;
  min-height: 100px;
}

/* Narrow number input */
.admin-input-narrow {
  width: 100px;
}

/* DB Cleanup results */
.admin-results-box {
  margin-top: 1rem;
  padding: 1rem;
  background: var(--color-surface);
  border-radius: 0.5rem;
  border: 1px solid var(--color-border);
}

.admin-results-box h4 {
  margin-bottom: 0.75rem;
  color: var(--color-text);
}

.admin-results-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.admin-results-item {
  padding: 0.5rem 0;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.admin-results-item:not(:last-child) {
  border-bottom: 1px solid var(--color-border);
}

.admin-results-status {
  font-weight: bold;
  min-width: 60px;
}

.admin-results-status.success {
  color: var(--color-success, #28a745);
}

.admin-results-status.failed {
  color: var(--color-danger, #dc3545);
}

.admin-cleanup-info {
  margin-top: 1rem;
  color: var(--color-text-secondary);
  font-size: 0.875rem;
}

.admin-cleanup-info ul {
  margin-top: 0.5rem;
  padding-left: 1.25rem;
}

/* Storage usage bar (Admin Users table) */
.storage-usage-bar {
  width: 80px;
  height: 14px;
  background: #e5e7eb;
  border-radius: 7px;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  position: relative;
}

.storage-usage-fill {
  height: 100%;
  border-radius: 7px;
  transition: width 0.3s ease;
}

.storage-usage-text {
  font-size: 0.75rem;
  color: #6b7280;
  margin-left: 0.4rem;
  vertical-align: middle;
  white-space: nowrap;
}

/* System Info tab */
.admin-system-info {
  max-width: 640px;
}

.system-info-version {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 0.75rem 1rem;
  background: #f3f4f6;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.system-info-version-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
}

.system-info-version-value {
  font-size: 1.25rem;
  font-weight: 600;
  color: #3b82f6;
  font-family: monospace;
}

.system-info-section-heading {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7280;
  margin: 1.25rem 0 0.6rem;
}

.system-info-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.system-info-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.75rem;
  background: #f3f4f6;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.system-info-stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
}

.system-info-stat-label {
  font-size: 0.7rem;
  color: #6b7280;
  margin-top: 0.2rem;
  text-align: center;
}

.system-info-refresh {
  margin-top: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/AdminPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+CAA+C;EAC/C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;EACpB,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mGAAmG;EACnG,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,MAAM;EACN,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,8CAA8C;EAC9C,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;EAGE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;EAIE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,qEAAqE;;AAErE,mFAAmF;AACnF;EACE,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;EAC5B,mCAAmC;EACnC,YAAY;EACZ,sBAAsB;AACxB;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".admin-page {\n  min-height: 100vh;\n  background: transparent;\n  position: relative;\n}\n\n/* Fixed background image for admin page */\n.admin-page::after {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: var(--background-image, none);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: var(--color-primary);\n  background-blend-mode: multiply;\n  background-attachment: fixed;\n  pointer-events: none;\n  z-index: -1;\n}\n\n/* Gradient overlay for admin page */\n.admin-page::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, var(--color-gradient-start) 0%, var(--color-gradient-end) 100%);\n  opacity: 0.2;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.admin-content {\n  display: flex;\n  align-items: flex-start;\n  padding: 1rem 1.5rem;\n  gap: 0;\n  min-height: calc(100vh - 64px);\n}\n\n.admin-sidebar {\n  width: 175px;\n  flex-shrink: 0;\n  background: var(--color-card-bg);\n  border-radius: 0.5rem;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  top: 1rem;\n  transition: width 0.2s ease;\n  overflow: hidden;\n}\n\n.admin-sidebar.collapsed {\n  width: 36px;\n  padding: 0.25rem;\n  align-items: center;\n}\n\n.admin-sidebar-toggle {\n  align-self: flex-end;\n  background: none;\n  border: 1px solid var(--color-border, #374151);\n  border-radius: 0.25rem;\n  cursor: pointer;\n  color: #9ca3af;\n  padding: 0.2rem 0.4rem;\n  font-size: 0.85rem;\n  line-height: 1;\n  margin-bottom: 0.5rem;\n  transition: color 0.15s;\n}\n\n.admin-sidebar.collapsed .admin-sidebar-toggle {\n  align-self: center;\n  margin-bottom: 0;\n}\n\n.admin-sidebar-toggle:hover {\n  color: #3b82f6;\n}\n\n.admin-nav-item {\n  display: block;\n  width: 100%;\n  padding: 0.45rem 0.75rem;\n  background: none;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-size: 0.78rem;\n  font-weight: 500;\n  color: #9ca3af;\n  text-align: left;\n  white-space: nowrap;\n  transition: all 0.15s;\n  margin-bottom: 0.1rem;\n}\n\n.admin-nav-item:hover {\n  background: rgba(59, 130, 246, 0.12);\n  color: #3b82f6;\n}\n\n.admin-nav-item.active {\n  background: #3b82f6;\n  color: #fff;\n}\n\n.admin-main {\n  flex: 1;\n  min-width: 0;\n  padding-left: 1.25rem;\n}\n\n.admin-section {\n  background: white;\n  border-radius: 0.5rem;\n  padding: 2rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.admin-section h2 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  color: var(--color-text-on-background);\n}\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.admin-table thead {\n  background: #f9fafb;\n}\n\n.admin-table th {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.admin-table th[style*=\"cursor: pointer\"]:hover {\n  background: #e5e7eb;\n  color: #1f2937;\n}\n\n.admin-table td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.admin-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.admin-table .btn-edit,\n.admin-table .btn-delete,\n.btn-edit,\n.btn-delete {\n  padding: 0.5rem 1rem;\n  margin-right: 0.5rem;\n  border: none;\n  border-radius: 9999px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: all 0.2s;\n}\n\n.admin-table .btn-edit,\n.btn-edit {\n  background: #3b82f6;\n  color: white;\n}\n\n.admin-table .btn-edit:hover,\n.btn-edit:hover {\n  background: #2563eb;\n}\n\n.admin-table .btn-delete,\n.btn-delete {\n  background: #ef4444;\n  color: white;\n}\n\n.admin-table .btn-delete:hover,\n.btn-delete:hover {\n  background: #dc2626;\n}\n\n.admin-modal {\n  max-width: 600px;\n  width: 90%;\n}\n\n.admin-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.admin-form.compact-form {\n  gap: 0.5rem;\n}\n\n.admin-form .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.admin-form label {\n  font-weight: 500;\n  color: #374151;\n}\n\n.admin-form input[type=\"text\"],\n.admin-form input[type=\"email\"],\n.admin-form input[type=\"password\"] {\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 1rem;\n  background-color: #ffffff;\n}\n\n/* Compact form rows */\n.compact-row {\n  display: grid;\n  grid-template-columns: 110px 1fr;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.compact-row label {\n  font-size: 0.8rem;\n  color: #6b7280;\n  font-weight: 500;\n  margin: 0;\n}\n\n.compact-row input[type=\"text\"],\n.compact-row input[type=\"email\"],\n.compact-row .password-input {\n  padding: 0.35rem 0.5rem;\n  font-size: 0.85rem;\n}\n\n.compact-row select {\n  padding: 0.35rem 0.5rem;\n  font-size: 0.85rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  background: #ffffff;\n}\n\n.compact-section-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #9ca3af;\n  margin-top: 0.25rem;\n  border-top: 1px solid #f3f4f6;\n  padding-top: 0.4rem;\n}\n\n.compact-toggle-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem 1rem;\n}\n\n.compact-check {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  cursor: pointer;\n  user-select: none;\n  font-size: 0.8rem;\n}\n\n.compact-check input[type=\"checkbox\"] {\n  width: 1rem;\n  height: 1rem;\n  cursor: pointer;\n  margin: 0;\n}\n\n.compact-check span {\n  color: #374151;\n}\n\n.compact-roles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem 1rem;\n}\n\n.admin-form textarea {\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  background-color: #ffffff;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.admin-form textarea:disabled {\n  background-color: #e5e7eb;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.admin-form textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.admin-form input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.roles-checkboxes {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: #f9fafb;\n  border-radius: 0.375rem;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 1.25rem;\n  height: 1.25rem;\n  cursor: pointer;\n}\n\n.checkbox-label span {\n  color: #374151;\n}\n\n.role-description {\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.modal-actions .btn-save,\n.modal-actions .btn-cancel,\n.btn-save,\n.btn-cancel {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 9999px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.modal-actions .btn-save,\n.btn-save {\n  background: #3b82f6;\n  color: white;\n}\n\n.modal-actions .btn-save:hover,\n.btn-save:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.btn-save:disabled {\n  background: #6b7280;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.modal-actions .btn-cancel,\n.btn-cancel {\n  background: #6b7280;\n  color: white;\n}\n\n.modal-actions .btn-cancel:hover,\n.btn-cancel:hover {\n  background: #4b5563;\n}\n\n/* Generic button styles for Interfaces tab */\n.button {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 9999px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.button-primary {\n  background: #3b82f6;\n  color: white;\n}\n\n.button-primary:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.button-primary:disabled {\n  background: #6b7280;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.button-secondary {\n  background: #6b7280;\n  color: white;\n}\n\n.button-secondary:hover:not(:disabled) {\n  background: #4b5563;\n}\n\n.button-secondary:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* ============== Interface & System Settings Styles ============== */\n\n/* Dark banner header for interface config sections (Email, SMS, App URL, OpenAI) */\n.admin-interface-header {\n  font-size: 1.25rem;\n  padding: 0.75rem 1rem;\n  margin: 0 -1rem 1.5rem -1rem;\n  background-color: var(--color-text);\n  color: white;\n  border-radius: 0.25rem;\n}\n\n/* Underline header for system settings sections (Theme, Threshold, Cleanup) */\n.admin-settings-header {\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid var(--color-border);\n  color: var(--color-text);\n}\n\n/* Config section spacing */\n.admin-config-section {\n  margin-top: 3rem;\n}\n\n.admin-config-section:first-child {\n  margin-top: 0;\n}\n\n/* System settings section spacing */\n.admin-settings-section {\n  margin-top: 2rem;\n}\n\n/* Description paragraph below section headers */\n.admin-section-description {\n  color: var(--color-text-secondary);\n  margin-bottom: 1.5rem;\n}\n\n/* Narrow form wrapper (600px max) */\n.admin-form-narrow {\n  max-width: 600px;\n}\n\n/* Helper text below form fields */\n.admin-help-text {\n  color: var(--color-text-secondary);\n  font-size: 0.875rem;\n}\n\n.admin-help-text a {\n  color: var(--color-primary);\n}\n\n.admin-help-text.block {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n/* Row of action buttons at bottom of forms */\n.admin-button-row {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n/* Test section divider */\n.admin-test-divider {\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.admin-test-divider h4 {\n  margin-bottom: 1rem;\n}\n\n/* Test input + button row */\n.admin-test-row {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-end;\n  max-width: 600px;\n}\n\n.admin-test-row .form-group {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.admin-test-row button {\n  height: fit-content;\n}\n\n/* Inline checkbox/radio label (row direction) */\n.admin-checkbox-inline {\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.admin-checkbox-inline.compact {\n  margin-bottom: 1rem;\n}\n\n.admin-checkbox-inline.no-margin {\n  margin-bottom: 0;\n}\n\n/* Radio option group */\n.admin-radio-group {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.admin-radio-group label {\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n}\n\n.admin-radio-group input[type=\"radio\"] {\n  margin-right: 0.5rem;\n}\n\n/* Email provider selection */\n.admin-provider-selection {\n  max-width: 600px;\n  margin-bottom: 2rem;\n}\n\n.admin-provider-selection > label {\n  display: block;\n  margin-bottom: 0.75rem;\n  font-weight: 500;\n}\n\n/* Full-width textarea */\n.admin-textarea-full {\n  width: 100%;\n  min-height: 100px;\n}\n\n/* Narrow number input */\n.admin-input-narrow {\n  width: 100px;\n}\n\n/* DB Cleanup results */\n.admin-results-box {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: var(--color-surface);\n  border-radius: 0.5rem;\n  border: 1px solid var(--color-border);\n}\n\n.admin-results-box h4 {\n  margin-bottom: 0.75rem;\n  color: var(--color-text);\n}\n\n.admin-results-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.admin-results-item {\n  padding: 0.5rem 0;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.admin-results-item:not(:last-child) {\n  border-bottom: 1px solid var(--color-border);\n}\n\n.admin-results-status {\n  font-weight: bold;\n  min-width: 60px;\n}\n\n.admin-results-status.success {\n  color: var(--color-success, #28a745);\n}\n\n.admin-results-status.failed {\n  color: var(--color-danger, #dc3545);\n}\n\n.admin-cleanup-info {\n  margin-top: 1rem;\n  color: var(--color-text-secondary);\n  font-size: 0.875rem;\n}\n\n.admin-cleanup-info ul {\n  margin-top: 0.5rem;\n  padding-left: 1.25rem;\n}\n\n/* Storage usage bar (Admin Users table) */\n.storage-usage-bar {\n  width: 80px;\n  height: 14px;\n  background: #e5e7eb;\n  border-radius: 7px;\n  overflow: hidden;\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n}\n\n.storage-usage-fill {\n  height: 100%;\n  border-radius: 7px;\n  transition: width 0.3s ease;\n}\n\n.storage-usage-text {\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin-left: 0.4rem;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n/* System Info tab */\n.admin-system-info {\n  max-width: 640px;\n}\n\n.system-info-version {\n  display: flex;\n  align-items: baseline;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n  padding: 0.75rem 1rem;\n  background: #f3f4f6;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.system-info-version-label {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #6b7280;\n}\n\n.system-info-version-value {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #3b82f6;\n  font-family: monospace;\n}\n\n.system-info-section-heading {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #6b7280;\n  margin: 1.25rem 0 0.6rem;\n}\n\n.system-info-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.system-info-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0.75rem;\n  background: #f3f4f6;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.system-info-stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #111827;\n}\n\n.system-info-stat-label {\n  font-size: 0.7rem;\n  color: #6b7280;\n  margin-top: 0.2rem;\n  text-align: center;\n}\n\n.system-info-refresh {\n  margin-top: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
